var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgNote2 = function SvgNote2(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-12": 10,
    "data-width-16": 13,
    "data-width-20": 16,
    "data-width-24": 19,
    "data-width-28": 22,
    viewBox: "0 0 9.1 9",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.25 3.338c0-.187.151-.338.337-.338h3.665a.337.337 0 0 1 0 .675H2.588a.337.337 0 0 1-.338-.337M2.25 5.138c0-.187.151-.338.337-.338h1.736a.337.337 0 1 1 0 .675H2.587a.34.34 0 0 1-.337-.337",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 1.81C0 .81.81 0 1.81 0h5.38C8.19 0 9 .81 9 1.81l-.033 1.223a.342.342 0 1 1-.684 0l.032-1.223c0-.622-.503-1.125-1.125-1.125H1.81C1.188.685.685 1.188.685 1.81v5.38c0 .622.503 1.125 1.125 1.125h2.445a.342.342 0 1 1 0 .685H1.81C.81 9 0 8.19 0 7.19z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.914 4.277c-.098-.002-.155.027-.172.044L7.4 4.67l.696.683.342-.348a.25.25 0 0 0 .076-.126.2.2 0 0 0-.01-.092.4.4 0 0 0-.068-.116l-.004-.004-.354-.348c-.002-.001-.016-.011-.046-.021a.4.4 0 0 0-.118-.02m-.185 1.45-.696-.683L5.517 6.59l-.221.922.917-.239zm.716-1.784.357.35-.184.188.184-.187.002.001.002.003.006.006a1 1 0 0 1 .069.083c.038.052.086.13.12.228a.7.7 0 0 1 .029.36.77.77 0 0 1-.218.397l-2.276 2.32a.26.26 0 0 1-.12.07l-1.412.367a.262.262 0 0 1-.321-.315l.34-1.418a.26.26 0 0 1 .068-.122l2.276-2.32c.158-.161.383-.206.559-.202.172.004.382.057.52.191",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNote2);
export default ForwardRef;